if (!customElements.get("product-recommendations")){
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
      // Merravè 2026-09-22: niet wachten tot ze in beeld scrollt; na het laden van de pagina alvast ophalen,
      // zodat de rij er staat als ze aankomt (stond soms 20 s leeg met alleen de kop).
      const vroeg = () => this.loadRecommendations(this.dataset.productId);
      if (document.readyState === "complete") setTimeout(vroeg, 800);
      else window.addEventListener("load", () => setTimeout(vroeg, 800), { once: true });
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: "0px 0px 2000px 0px" }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      if (this.mrvGeladen) return;
      this.mrvGeladen = true;
      this.observer?.unobserve(this);
      fetch(
        `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
      )
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          } else {
            this.classList.add("product-recommendations--leeg");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
  
  customElements.define("product-recommendations", ProductRecommendations);
}